export default __webpack_public_path__ + "static/setsquare-69496b1cb1d9f9f8ee76b39396a321d0.png";